import { DatePipe } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { JobFilter } from '../../job/models/job.filter';
import { JobService } from '../../job/services/job.service';
import { Crew } from '../../shared/models/crew.interface';
import { FieldTechnician } from '../../shared/models/field.technician.interface';
import { Job } from '../../shared/models/job.interface';
import { MonthType } from '../../shared/models/month.type.interface';
import { FileService } from '../../shared/services/file.service';
import { WorkOrderService } from '../../work-order/services/work.order.service';
import { AbstractReportComponent } from '../abstract.report.component';
import { EmailLog, EmailLogMessage, EmailLogResult } from '../models/email.log.interface';
import { ReportService } from '../services/report.service';
import { Dealer } from '../../shared/models/dealer.interface';
import { AdminService } from '../../admin/services/admin.service';

export interface EmailLogParameterData {
  emailLogData: EmailLog;
  validation: string;
  startDate: Date;
  endDate: Date;
  dealers: Dealer[];
  isIDIAdmin: boolean;
}

@Component({
  selector: 'app-email-log',
  templateUrl: './email.log.component.html',
  styleUrls: ['./email.log.component.scss']
})
/** EmailLog component*/
export class EmailLogComponent extends AbstractReportComponent {

  report: EmailLogResult[] = [];
  parameters: EmailLog = {
    startDate: '',
    endDate: '',
    dealer_ID: null
  } as EmailLog;

  startDate = new Date();
  endDate = new Date();
  dealers: Dealer[] = [];
  isIDIAdmin: boolean = false;

  /** payrollSummary ctor */
  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService, private datepipe: DatePipe,
    dialog: MatDialog, 
    private reportService: ReportService, private fileService: FileService, private adminService: AdminService) {
    super(locale, dialog, deviceDetectorService);

    this.startDate.setMonth(this.endDate.getMonth() - 1);
    
    this.setupDates();
    if (ReportService._authNavStatusSource.value == "IDI") {

      this.isIDIAdmin = true;
      this.adminService.getDealers()
        .subscribe({
          next: (data) => {
            this.dealers = data;
          },
          complete: () => {
            this.showParameters();
          },
          error: (error: string) => this.onError(error)
        });
    }
    else {
      this.showParameters();
    }

  }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;
        this.reportService.getEmailLogExport(this.parameters, formatData.format, formatData.locale)
          .subscribe({
            next: (data: Blob) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'EmailLog' + formatData.extension);
            },
            error: (error: string) => this.onError(error)
          });
      });
  }

  showDetails(event: Event, message: EmailLogMessage) {
    event.preventDefault();

    this.showDialog(message.emailEventMessage_Event === 'ERROR' ?  message.emailEventMessage_Response : message.emailEventMessage_Payload, 'Event Details');
  }

  showParameters() {
    const dialogRef = this.dialog.open(EmailLogParameterDialog, {
      width: '550px',
      data: {
        emailLogData: (<any>Object).assign({}, this.parameters),
        startDate: this.startDate,
        endDate: this.endDate,
        dealers: this.dealers,
        isIDIAdmin: this.isIDIAdmin
      } as EmailLogParameterData
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.parameters = result.emailLogData as EmailLog;
        this.startDate = result.startDate;
        this.endDate = result.endDate;

        this.parameters.startDate = this.datepipe.transform(this.startDate, 'yyyy-MM-ddT00:00:00');
        this.parameters.endDate = this.datepipe.transform(this.endDate, 'yyyy-MM-ddT00:00:00');
        this.parameters.dealer_ID = result.emailLogData.dealer_ID;

        this.reportService.getEmailLogReport(this.parameters)
          .subscribe({
            next: (data: EmailLogResult[]) => {
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}

@Component({
  selector: 'email-log.parameter.dialog',
  templateUrl: 'email.log.parameter.dialog.html',
})
export class EmailLogParameterDialog {

  errors: string = '';
  isIDIAdmin: boolean = false;
  dealers: Dealer[] = []
  dealerId: number = null;

  constructor(
    public dialogRef: MatDialogRef<EmailLogParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: EmailLogParameterData) {

  }

  runReport(form: NgForm): void {
    this.errors = '';

    if (!form.valid) {
      return;
    }

    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  isValid() { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
